import { render } from "./AdvisoryProgramm.vue?vue&type=template&id=25bce878"
import script from "./AdvisoryProgramm.vue?vue&type=script&lang=js"
export * from "./AdvisoryProgramm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__